import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

const RequestCardSkeletonMobile = ({ isHistory = false }) => {
  return (
    <Box
      elevation={2}
      sx={{
        borderRadius: "16px",
        p: 2,
        mb: 2,
        position: "relative",
        overflow: "hidden",
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* ID Badge - Skeleton element */}
      <Skeleton
        variant="rectangular"
        width={60}
        height={20}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          borderBottomRightRadius: "12px",
        }}
      />

      {/* Info Section: Name, Phone, Price */}
      <Stack 
        direction="row" 
        alignItems="center" 
        justifyContent="space-between" 
        mt={3} 
        mr={5} 
        ml={0}
        spacing={2}
      >
        <Box>
          {/* Avatar + Name/Phone skeleton */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={48} height={48} />
            <Stack spacing={0.5}>
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="text" width={100} height={16} />
            </Stack>
          </Box>
        </Box>

        {/* Cost section */}
        <Box sx={{ textAlign: "right" }}>
          <Skeleton variant="text" width={60} height={14} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width={50} height={18} />
        </Box>
      </Stack>

      {/* Delivery Slot */}
      <Box mt={2}>
        <Skeleton variant="text" width={80} height={14} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width={100} height={18} />
      </Box>

      {/* Actions */}
      <Box mt={2}>
        {isHistory ? (
          <Stack direction="row" justifyContent="space-between" spacing={1}>
            <Skeleton variant="rounded" width={90} height={32} sx={{ borderRadius: "50px" }} />
            <Skeleton variant="rounded" width={90} height={32} sx={{ borderRadius: "50px" }} />
          </Stack>
        ) : (
          <Stack direction="row" spacing={1} alignItems="center">
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton variant="circular" width={40} height={40} />
            <Box sx={{ flex: 1 }} />
            <Skeleton variant="rounded" width={100} height={32} sx={{ borderRadius: "50px" }} />
          </Stack>
        )}
      </Box>
    </Box>
  );
};

const RequestCardSkeletonMobileList = ({ rows = 5, isHistory = false }) => {
  return (
    <Box>
      {[...Array(rows)].map((_, i) => (
        <RequestCardSkeletonMobile key={i} isHistory={isHistory} />
      ))}
    </Box>
  );
};

export default RequestCardSkeletonMobileList;
